import { OTPField } from "@overmap-ai/forms"
import type { ReactNode } from "react"

import {
	NullableStringEqualsFilterModifier,
	NullableStringNotEqualsFilterModifier,
	StringExcludesFilterModifier,
	StringIncludesFilterModifier,
} from "../../modifiers"
import { BaseFilterDef, createFilterModifierConfig, type FilterDefRenderProps } from "../BaseFilterDef"
import { OTPFieldFilterCell } from "./OTPFieldFilterCell"

type OTPFieldValue = string | null
type OTPFilterValue = string | null

export class OTPFieldFilterDef extends BaseFilterDef<OTPFieldValue, OTPFilterValue> {
	readonly id: string
	readonly defaultFilterValue: OTPFilterValue | undefined = undefined
	readonly defaultFilterModifier: keyof typeof this.modifiers = "equals"

	readonly field: OTPField

	constructor(field: OTPField) {
		super()
		this.field = field
		this.id = field.id
	}

	readonly modifiers = {
		equals: createFilterModifierConfig({
			modifier: NullableStringEqualsFilterModifier,
			isValueValid: (_value: OTPFieldValue): _value is string => true,
			isFilterValueValid: (_filterValue: OTPFilterValue): _filterValue is string | null => true,
		}),
		notEquals: createFilterModifierConfig({
			modifier: NullableStringNotEqualsFilterModifier,
			isValueValid: (value: OTPFieldValue): value is string => value !== null,
			isFilterValueValid: (_filterValue: OTPFilterValue): _filterValue is string | null => true,
		}),
		includes: createFilterModifierConfig({
			modifier: StringIncludesFilterModifier,
			isValueValid: (value: OTPFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: OTPFilterValue): filterValue is string => filterValue !== null,
		}),
		excludes: createFilterModifierConfig({
			modifier: StringExcludesFilterModifier,
			isValueValid: (value: OTPFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: OTPFilterValue): filterValue is string => filterValue !== null,
		}),
	}

	render(props: FilterDefRenderProps<OTPFieldFilterDef>): ReactNode {
		return <OTPFieldFilterCell key={props.filter.id} field={this.field} {...props} />
	}
}
